/* eslint-disable @typescript-eslint/no-namespace */
import { z } from 'zod';

export const ApplicationStatusSchema = z.enum([
  'VALIDATED',
  'UPCOMING',
  'UNDER_VALIDATION',
  'UNVALIDATED',
  'PREVIEW_ONLY',
]);

export type ApplicationStatus = z.infer<typeof ApplicationStatusSchema>;

export const ApplicationPromotionSchema = z.enum(['HOT_OFFER']);

export type ApplicationPromotion = z.infer<typeof ApplicationPromotionSchema>;

export const ApplicationBadgeTypeSchema = ApplicationStatusSchema.or(ApplicationPromotionSchema);

export type ApplicationBadgeType = z.infer<typeof ApplicationBadgeTypeSchema>;

export const ApplicationOldValidationStatusSchema = z.enum([
  'CREATED',
  'DEPLOYING',
  'FAILED',
  'DONE',
  'DISABLE',
  'INVALID',
  'TOFIX',
  'APPROVED',
  'ONPREAPPROVE',
  'PENDING',
  'VALIDATORS_ADDED',
  'ROUND_STARTED',
  'FAILED_REFUND_TAKEN',
  'WAITING_FOR_STAKE',
  'WAITING_FOR_VOTE_START',
]);

export type ApplicationOldStatus = z.infer<typeof ApplicationOldValidationStatusSchema>;

export const ApplicationNewValidationStatusSchema = z.enum([
  'EXTERNAL_VALIDATION_FAILED_NO_QUORUM',
  'EXTERNAL_VALIDATION_SUCCESS',
  'EXTERNAL_VALIDATION_FAILED_BAD_SCORE',
  'INTERNAL_VALIDATION_SUCCESS',
  'PROD_READY_ON_PREAPPROVE',
  'UPCOMMING_ON_PREAPPROVE',
  'EXTERNAL_VALIDATION',
  'PROD_READY_TO_FIX',
  'UPCOMMING_TO_FIX',
  'UPCOMMING_ON_PREAPPROVE_APPROVED',
  'PROD_READY_ON_PREAPPROVE_PROPOSAL_CREATION_ATTEMPT',
  'REVALIDATION_UPCOMMING_ON_PREAPPROVE',
  'REVALIDATION_PROD_READY_ON_PREAPPROVE',
  'APP_REJECTED',
  'READ_ONLY',
]);

export type ApplicationNewValidationStatus = z.infer<typeof ApplicationNewValidationStatusSchema>;

export const ApplicationValidationStatusSchema = z.union([
  ApplicationOldValidationStatusSchema,
  ApplicationNewValidationStatusSchema,
]);

export type ApplicationValidationStatus = z.infer<typeof ApplicationValidationStatusSchema>;

const APPLICATION_VALIDATION_STATUS_MAP: Partial<
  Record<ApplicationValidationStatus, ApplicationStatus | 'UNAVAILABLE'>
> = {
  APP_REJECTED: 'UNAVAILABLE',
  EXTERNAL_VALIDATION_FAILED_BAD_SCORE: 'UNVALIDATED',
  EXTERNAL_VALIDATION_FAILED_NO_QUORUM: 'UNVALIDATED',
  EXTERNAL_VALIDATION_SUCCESS: 'VALIDATED',
  EXTERNAL_VALIDATION: 'UNDER_VALIDATION',
  INTERNAL_VALIDATION_SUCCESS: 'VALIDATED',
  READ_ONLY: 'PREVIEW_ONLY',
  UPCOMMING_ON_PREAPPROVE_APPROVED: 'UPCOMING',
  PROD_READY_ON_PREAPPROVE_PROPOSAL_CREATION_ATTEMPT: 'UNAVAILABLE',
};

// eslint-disable-next-line no-redeclare
export namespace ApplicationStatus {
  export const from = (validationStatus: ApplicationValidationStatus) => {
    return APPLICATION_VALIDATION_STATUS_MAP[validationStatus];
  };
}
